import * as React from 'react';

import {colors} from 'shells/colors/colors';

import type {
    PeepRelatedLeadStats,
    PeepRelatedLeadCards,
    PeepRelatedLeadCards_childLeads_edges,
} from 'nutshell-graphql-types';

import {
    LeadCardDynamicWrapper,
    mapLeadToListItem,
    DEFAULT_LEAD_CARD_FIELDS,
} from '../lead/lead-card-dynamic';

export const PEEP_RELATED_LEAD_STATS_UPDATE_EVENT_NAME = 'updatePeepRelatedLeadStats';

export const getStatsToRender = (
    peep: PeepRelatedLeadStats,
    showChildLeadInfo?: boolean | null
) => {
    // @ts-expect-error
    let statsToRender = [];
    if (showChildLeadInfo && peep.childLeads.subsidiaryStats) {
        statsToRender = peep.childLeads.subsidiaryStats.all;
    } else if (!showChildLeadInfo) {
        statsToRender = peep.leads.stats.all;
    }

    // We only got room for 4 stats, let's omit pending if this
    // lead happens to have leads of all 5 types
    if (statsToRender.length === 5) {
        // @ts-expect-error
        statsToRender = statsToRender.filter((stat) => stat.status !== 'PENDING');
    }

    return statsToRender;
};

export const getEmptyStateMessage = (
    peep: PeepRelatedLeadStats,
    showChildLeadInfo?: boolean | null
): string => {
    let emptyStateMessage = null;
    if (peep.__typename !== 'Account') {
        emptyStateMessage = 'This person has no associated leads';
    } else if (!showChildLeadInfo) {
        emptyStateMessage = 'This company has no associated leads';
    } else {
        emptyStateMessage = 'Child companies have no leads';
    }

    return emptyStateMessage;
};

export const getCollection = (
    peep?: PeepRelatedLeadCards | null,
    showChildLeadInfo?: boolean | null
) => {
    // @ts-expect-error
    let collection = [];
    if (peep) {
        if (showChildLeadInfo) {
            collection = peep.childLeads.edges;
        } else {
            collection = peep.leads.edges;
        }
    }

    // @ts-expect-error
    return collection;
};

export const renderLeadCard = (edge: PeepRelatedLeadCards_childLeads_edges, onNavigate: any) => {
    const lead = edge.node;
    const listItem = mapLeadToListItem(lead);

    return (
        <LeadCardDynamicWrapper
            key={lead.id}
            listItem={listItem}
            linkable={true}
            borderColor={colors.offWhiteDk}
            hasActionMenu={false}
            onNavigate={onNavigate}
            fieldsToDisplay={DEFAULT_LEAD_CARD_FIELDS}
        />
    );
};

export const updatePeepRelatedLeadStats = () => {
    window.dispatchEvent(new Event(PEEP_RELATED_LEAD_STATS_UPDATE_EVENT_NAME));
};
